import { takeLatest, all, call, put } from "redux-saga/effects";
import { setNotificationAction } from "../NotificationStore/notification.slice.selector";
import { completedFetch, completedNewAdd, setTemplateFilterList, setTemplateList, setUserTemplateList, startAddNewTemplate, startDeleteTemplateList, startGettingFilterTemplateList, startGettingTemplateList, startTemplateListByUserId } from "./template.slice.selector";
import { addNewTemplate, getAllTemplate, getDeleteAllTemplate, getFilterAllTemplate, getUserTemplateByUserId } from "../../../Apis/Template/template";
//(1) Watcher
function* startFetchTemplateList() {
  yield takeLatest(startGettingTemplateList.type, setTemplateListData);
}
//(1) Next
function* setTemplateListData({ payload }) {
  try {
    const response_data = yield call(getAllTemplate, payload);

    yield put(setTemplateList(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(1.5) Watcher
function* startFetchFilterTemplateList() {
  yield takeLatest(startGettingFilterTemplateList.type, setFilteredTemplateListData);
}
//(1.5) Next
function* setFilteredTemplateListData({ payload }) {
  try {
    const response_data = yield call(getFilterAllTemplate, payload);

    yield put(setTemplateFilterList(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(2)Wacther
function* startAddingNewTemplate() {
  yield takeLatest(startAddNewTemplate.type, callForAddingNewTemplate);
}
//(2)Next
function* callForAddingNewTemplate({ payload }) {
  try {
    // const { data } = payload;
    yield call(addNewTemplate, payload);
    yield put(completedNewAdd());
    yield put(startGettingTemplateList({
      pageIndex: 1,
      pageSize: 10,
    }));
    yield put(setNotificationAction({
      message: "User Added Successfully",
      variant: "success",
    })
    );
    // yield put(startGettingTemplateList(tableData));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );

  }
}

//(3) Watcher
function* startFetchUserTemplateList() {
  yield takeLatest(startTemplateListByUserId.type, setuserTemplateListData);
}
//(3) Next
function* setuserTemplateListData({ payload }) {
  try {
    const response_data = yield call(getUserTemplateByUserId, payload);

    yield put(setUserTemplateList(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(4) Watcher
function* startDeleteTemplateListData() {
  yield takeLatest(startDeleteTemplateList.type, setDelTemplateListData);
}
//(4) Next
function* setDelTemplateListData({ payload }) {
  try {
    const response_data = yield call(getDeleteAllTemplate, payload);
    yield put(completedFetch());
    yield put(startGettingTemplateList({
      pageIndex: 1,
      pageSize: 10,
    }));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

///Accumulator
export default function* templateSaga() {
  yield all([
    call(startFetchTemplateList),
    call(startFetchFilterTemplateList),
    call(startAddingNewTemplate),
    call(startFetchUserTemplateList),
    call(startDeleteTemplateListData),
  ]);
}
